import { Pipe, PipeTransform } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document, Block, Inline, BLOCKS } from '@contentful/rich-text-types';

interface ContentfulAssetFields {
  file?: {
    url?: string;
    details?: {
      image?: {
        height?: number;
        width?: number;
      };
    };
  };
  description?: string;
}

interface ContentfulAssetData {
  target?: {
    fields?: ContentfulAssetFields;
  };
}

type RenderNodeFunction = (node: Block | Inline) => string;

interface RenderOptions {
  renderNode?: {
    [key: string]: RenderNodeFunction;
  };
}

@Pipe({
  name: 'toHtml',
  standalone: true,
})
export class ToHtmlPipe implements PipeTransform {
  /**
   * Transforms a Contentful rich text document to HTML string
   * @param value - The rich text document to transform
   * @param args - Additional transformation arguments (currently unused)
   * @returns The HTML string representation
   */
  transform(value: unknown, ...args: never[]): string {
    if (!value) {
      return '';
    }

    try {
      const renderAsset: RenderNodeFunction = (node: Block | Inline): string => {
        const assetData = node.data as ContentfulAssetData;
        
        if (!assetData?.target?.fields) {
          return '';
        }

        const fields = assetData.target.fields;
        const imageUrl = fields.file?.url || '';
        const height = fields.file?.details?.image?.height || '';
        const width = fields.file?.details?.image?.width || '';
        const altText = fields.description || '';

        if (!imageUrl) {
          return '';
        }

        return `<img src="${imageUrl}" height="${height}" width="${width}" alt="${altText}" loading="lazy"/>`;
      };

      const options: RenderOptions = {
        renderNode: {
          [BLOCKS.EMBEDDED_ASSET]: renderAsset,
        },
      };

      return documentToHtmlString(value as Document, options);
    } catch (error: unknown) {
      console.error('Error transforming Contentful document to HTML:', error);
      return '';
    }
  }
}
